import styled from 'styled-components'
import { Modal } from 'react-bootstrap'

const StyledModal = styled(Modal)`
    width: 100%;

    .message-container {
        text-align: center;
    }

    .modal-content {
        padding: 10px;
        display: block;
        margin: auto;
    }

    .modal-img {
        width: 230px;
        display: block;
        margin: 0 auto;
    }


    .form-label {
        font-weight: 600;
    }

    .form-group {
        margin-bottom: 0.5rem;
    }

    .modal-body {
        display: flex;
        justify-content: center;
    }

    .modal-title {
        width: 100%;
    }

    .contactForm-container {
        width: 100%;
        color: #512e80;
        margin: 0 auto;
    }

    h4, h5 {
        font-weight: 600;
        font-size: 22px;
        color: #512e80;
        padding: 0;
    }

    h5 {
        text-transform: uppercase;
    }

    p {
        font-size: 18px;
        padding: 0; 
        margin: 0;    
        font-weight: 500;
        line-height: 1.5rem;
    }

    .header-content {
        text-align: left;
    }

    span {
        color: #512e80;
        font-weight: bold;
        text-transform: uppercase;
    }

    .movie-img {
        width: 100px;
        padding-bottom: 5px;
    }

    .modal__content {
        width: 100%;
    }

    .modal__text {
        text-align: center;
    }

    .reCaptcha.is-invalid, .was-validated .reCaptcha:invalid {
        border: 1px solid #dc3545;
        border-radius: 5px;
        width: 304px;
        height: 78px;
    }

`

export default StyledModal;
